/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    }
    else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp                 = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },

    // Auth
    clearAuthData(state) {
      state.token = null;
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
      localStorage.removeItem("expiredIn");
      localStorage.removeItem("authurl");
    },
  
    setAuthDB(state, url) {
      state.authdb = url;
    },
  
    setDBUrl(state, url) {
      state.dburl = url
    },
  
    setuserRole(state, val) {
      state.userRole = val;
    },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay       = val   },
  UPDATE_PRIMARY_COLOR(state, val)   { state.themePrimaryColor = val   },
  UPDATE_THEME(state, val)           { state.theme             = val   },
  UPDATE_WINDOW_WIDTH(state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY           = val   },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {

    // Get Data localStorage
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] != null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },

  // Language ///  
  setLanguage(state, val) {
    state.chlang = val
  },

  // Grid ///  
  setInbordersGrid(state, val) {
    state.inbordersgrid = val
  },
  setVendorsGrid(state, val) {
    state.vendorsgrid = val
  },
  setPosGrid(state, val) {
    state.posgrid = val
  },
  setProductTypesGrid(state, val) {
    state.producttypesgrid = val
  },
  setProductsGrid(state, val) {
    state.productsgrid = val
  },
  setBlocksTransGrid(state, val) {
    state.blockstransgrid = val
  },
  setSlabsTransGrid(state, val) {
    state.slabstransgrid = val
  },
  setLocationsGrid(state, val) {
    state.locationsgrid = val
  },
  setBlocksGrid(state, val) {
    state.blocksgrid = val
  },
  setInvoicesGrid(state, val) {
    state.invoicesgrid = val
  },
  setPosState(state, val) {
    state.posstate = val
  },
  setInvoicesState(state, val) {
    state.invoicesstate = val
  },
  setSlabsState(state, val) {
    state.slabsstate = val
  },
  setSlabsGrid(state, val) {
    state.slabsgrid = val
  },
  setBlockscutGrid(state, val) {
    state.blockscutgrid = val
  },
  setSlabscutGrid(state, val) {
    state.slabscutgrid = val
  },
  setSlabscutState(state, val) {
    state.slabscutstate = val
  },
  setBlockscutitemsGrid(state, val) {
    state.blockscutitemsgrid = val
  },
  setSlabscutitemsGrid(state, val) {
    state.slabscutitemsgrid = val
  },
  setBlockscutState(state, val) {
    state.blockscutstate = val
  },
  setBlockscutitemsState(state, val) {
    state.blockscutitemsstate = val
  },
  setSlabscutitemsState(state, val) {
    state.slabscutitemsstate = val
  },
  setSlabsFinalsGrid(state, val) {
    state.slabsfinalsgrid = val
  },
  setSlabsFinalsTransGrid(state, val) {
    state.slabsfinalstransgrid = val
  },
  setModesGrid(state, val) {
    state.modesgrid = val
  },
  setTermsGrid(state, val) {
    state.termsgrid = val
  },
  setPortsGrid(state, val) {
    state.portsgrid = val
  },
  setCountrysGrid(state, val) {
    state.countrysgrid = val
  },
  setFinaccsGrid(state, val) {
    state.finaccsgrid = val
  },
  setFinaccsubsGrid(state, val) {
    state.finaccsubsgrid = val
  },
  setMinproduct(state, val) {
    state.minproduct = val
  },
  setCompanysTypesGrid(state, val) {
    state.companystypesgrid = val
  },
  setCompanysGrid(state, val) {
    state.companysgrid = val
  },
  setBanksGrid(state, val) {
    state.banksgrid = val
  },
  setComid(state, val) {
    state.comid = val
  },
  setRemarksGrid(state, val) {
    state.remarksgrid = val
  },
  setAssetsGrid(state, val) {
    state.assetsgrid = val
  },
  setStocksGrid(state, val) {
    state.stocksgrid = val
  },
  setPosdepositsGrid(state, val) {
    state.posdepositsgrid = val
  },
  setPosinfor(state, val) {
    state.posinfor.pos_number = val
  },
  setPoscreditinfor(state, val) {
    state.poscreditinfor.pos_number = val
  },
  setBlockscutinfor(state, val) {
    state.blockscutinfor.blocks_code = val
  },
  setSlabscutinfor(state, val) {
    state.slabscutinfor.slabs_code = val
  },
  setPosData(state, val) {
    state.posdata = val
  },
  setPosDataDel(state, val) {
    state.posdatadel = val
  },
  setPosDataDelState(state, val) {
    state.posdatadelstate = val
  },
  setPosDataDelState2(state, val) {
    state.posdatadelstate2 = val
  },
  setRemarkData(state, val) {
    state.remarkdata = val
  },
  setRemarkDataDel(state, val) {
    state.remarkdatadel = val
  },
  setSaveState(state, val) {
    state.savestate = val
  },
  inboundConfirm(state, val) {
    state.inboundConfirm = val
  },
  getSelectedPO(state, val) {
    state.posselected = val
  },
  callItemlistPO(state, val) {
    state.itemlist = val
  },
  setSumState(state, val) {
    state.sumstate = val
  },
  SethotPoitemsHide(state, val) {
    state.hotPoitemsHide = val
  },
  setSelectState(state, val) {
    state.selectState = val
  },
  setM3Exc(state, val) {
    state.m3_amount_exc = val
  },
  setM3Can(state, val) {
    state.m3_cancel = val
  },
  setM3Rem(state, val) {
    state.m3_amount_remain = val
  },
  setM3RR(state, val) {
    state.m3_rr = val
  },
  setNblockName(state, val) {
    state.nblockname = val
  },
  setNbRunning(state, val) {
    state.nbrunning = val
  },
  setChkDup(state, val) {
    state.chkdup = val
  },
  setSentBlock(state, val) {
    state.sentblock = val
  },
  setSentSlab(state, val) {
    state.sentslab = val
  },
  setSlabsFinalShow(state, val) {
    state.slabsfinalshow = val
  },
  setReportGrid(state, val) {
    state.reportgrid = val
  },
}

export default mutations

